// Placeholders — replace with real links before publishing.
export const contact = {
  email: "amol.mali0588@gmail.com",
  linkedin: "https://www.linkedin.com/in/amol-mali-b20747154",
  github: "https://github.com/amol-dev-hash",
};
